"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapRenderCertificationsToIndicatorProps = exports.mapRenderWarningsToIndicatorsProps = exports.upstreamOfThisAssetMessage = exports.onThisAssetMessage = void 0;
var Localize_1 = require("../../../gen-src/Localize");
var DataQualityType_1 = require("../dataQualityWarnings/DataQualityType");
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
/**
 * @deprecated TFS-1478812
*/
function onThisAssetMessage(assetType) {
    if (!assetType) {
        return Localize_1.Messages.DataQualityContainerAnchored();
    }
    switch (assetType) {
        case 'Column': return Localize_1.Messages.DataQualityIndicatorContainer_onthis_asset_column();
        case 'CloudFile':
        case 'DatabaseServer':
        case 'File':
        case 'WebDataConnector': return Localize_1.Messages.DataQualityIndicatorContainer_onthis_asset_database();
        case 'VirtualConnectionTable':
        case 'DatabaseTable': return Localize_1.Messages.DataQualityIndicatorContainer_onthis_asset_table();
        case 'Flow': return Localize_1.Messages.DataQualityIndicatorContainer_onthis_asset_flow();
        case 'PublishedDatasource': return Localize_1.Messages.DataQualityIndicatorContainer_onthis_asset_datasource();
        case 'VirtualConnection': return Localize_1.Messages.DataQualityIndicatorContainer_onthis_asset_connection();
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(assetType);
            return '';
    }
}
exports.onThisAssetMessage = onThisAssetMessage;
/**
 * @deprecated TFS-1478812
*/
function upstreamOfThisAssetMessage(assetType) {
    if (!assetType) {
        return Localize_1.Messages.DataQualityContainerUpstream();
    }
    switch (assetType) {
        case 'Metric': return Localize_1.Messages.DataQualityIndicatorContainer_upstreamof_asset_metric();
        case 'CloudFile':
        case 'DatabaseServer':
        case 'File':
        case 'Column':
        case 'WebDataConnector': return Localize_1.Messages.DataQualityIndicatorContainer_upstreamof_asset_database();
        case 'Workbook': return Localize_1.Messages.DataQualityIndicatorContainer_upstreamof_asset_workbook();
        case 'VirtualConnectionTable':
        case 'DatabaseTable': return Localize_1.Messages.DataQualityIndicatorContainer_upstreamof_asset_table();
        case 'VirtualConnection': return Localize_1.Messages.DataQualityIndicatorContainer_upstreamof_asset_connection();
        case 'Flow': return Localize_1.Messages.DataQualityIndicatorContainer_upstreamof_asset_flow();
        case 'EmbeddedDatasource':
        case 'PublishedDatasource': return Localize_1.Messages.DataQualityIndicatorContainer_upstreamof_asset_datasource();
        case 'View': return Localize_1.Messages.DataQualityIndicatorContainer_upstreamof_asset_view();
        case 'Field': return Localize_1.Messages.DataQualityIndicatorContainer_upstreamof_asset_field();
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(assetType);
            return '';
    }
}
exports.upstreamOfThisAssetMessage = upstreamOfThisAssetMessage;
function mapGraphDataQualityWarningToUpstreamRenderIndicatorAssetProps(params) {
    var kind = 'graph';
    var groups = {};
    params.warnings.filter(function (t) { return t.isActive; }).map(function (w) {
        var _a;
        return {
            remoteType: ((_a = w.asset) === null || _a === void 0 ? void 0 : _a.__typename) === 'Column' ? w.asset.remoteType : undefined,
            assetName: assetName({ kind: kind, asset: __assign({}, w) }),
            assetType: assetType({ kind: kind, asset: __assign({}, w) }),
            assetUrl: assetUrl(params.urls, { kind: kind, asset: __assign({}, w) }),
            indicators: [mapRenderWarningsToIndicatorProps(__assign(__assign({}, w), { linksDisabled: params.linksDisabled, newTab: params.newTab }))]
        };
    }).forEach(function (i) {
        var _a;
        var _b, _c;
        var name = (_b = i.assetName) !== null && _b !== void 0 ? _b : '';
        if (groups[name]) {
            (_c = groups[name]) === null || _c === void 0 ? void 0 : (_a = _c.indicators).push.apply(_a, i.indicators);
        }
        else {
            groups[name] = i;
        }
    });
    return (0, TypescriptHelpers_1.filterOutNullAndUndefined)(Object.keys(groups).map(function (k) {
        var g = groups[k];
        if (!g) {
            return null;
        }
        return __assign(__assign({}, g), { indicators: g.indicators.sort(function (t) { return t.kind === 'severe-warning' ? -1 : 1; }) });
    }));
}
function mapRenderWarningsToIndicatorProps(props) {
    var _a, _b, _c, _d, _e;
    return {
        linksDisabled: props.linksDisabled,
        newTab: props.newTab,
        author: {
            name: ((_a = props.author) === null || _a === void 0 ? void 0 : _a.name) || props.authorDisplayName,
            username: (_c = (_b = props.author) === null || _b === void 0 ? void 0 : _b.username) !== null && _c !== void 0 ? _c : null,
            domain: (_e = (_d = props.author) === null || _d === void 0 ? void 0 : _d.domain) !== null && _e !== void 0 ? _e : null
        },
        localizedDate: Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(props.updatedAt)),
        message: props.message,
        type: dataQualityType(props),
        kind: dataQualityKind(props),
        id: props.id,
    };
}
function mapRenderWarningsToIndicatorAssetProps(props) {
    var _a, _b;
    var asset = props.kind === 'graph' ? {
        kind: 'graph',
        asset: props.anchoredAsset,
    } : {
        kind: 'vizportal',
        asset: props.anchoredAsset,
    };
    var partial = {
        subjectArea: props.subjectArea,
        assetName: assetName(asset),
        assetType: assetType(asset),
        assetUrl: assetUrl(props.urls, asset),
        remoteType: (props.kind === 'graph' && ((_b = (_a = props.anchoredAsset) === null || _a === void 0 ? void 0 : _a.asset) === null || _b === void 0 ? void 0 : _b.__typename) === 'Column') ? props.anchoredAsset.asset.remoteType : undefined,
    };
    switch (props.kind) {
        case 'graph': {
            return __assign(__assign({}, partial), { indicators: props.anchoredWarnings.filter(function (t) { return t.isActive; }).map(function (t) { return mapFragmentOrIDataQualityIndicatorToRenderIndicatorProps(__assign({ kind: 'graph' }, t)); }) });
        }
        case 'vizportal': {
            return __assign(__assign({}, partial), { indicators: props.anchoredWarnings.filter(function (t) { return t.isActive; }).map(function (t) { return mapFragmentOrIDataQualityIndicatorToRenderIndicatorProps(__assign({ kind: 'vizportal' }, t)); }) });
        }
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(props);
            return {};
    }
}
/**
 * @deprecated TFS-1478812
*/
function mapRenderWarningsToIndicatorsProps(props) {
    var _a, _b;
    var asset = mapRenderWarningsToIndicatorAssetProps(props);
    var upstream = mapGraphDataQualityWarningToUpstreamRenderIndicatorAssetProps({
        warnings: props.upstreamWarnings.filter(function (t) { return t.isActive; }),
        urls: props.urls,
        linksDisabled: props.linksDisabled,
        newTab: props.newTab,
    });
    var childrenIndicatorAndAsset = mapGraphDataQualityWarningToUpstreamRenderIndicatorAssetProps({
        warnings: (_b = (_a = props.anchoredChildWarnings) === null || _a === void 0 ? void 0 : _a.filter(function (t) { return t.isActive; })) !== null && _b !== void 0 ? _b : [],
        urls: props.urls,
        linksDisabled: props.linksDisabled,
        newTab: props.newTab,
    });
    return __assign(__assign({}, asset), { childrenIndicatorAndAsset: childrenIndicatorAndAsset, upstream: upstream });
}
exports.mapRenderWarningsToIndicatorsProps = mapRenderWarningsToIndicatorsProps;
/**
 * @deprecated TFS-1478812
*/
function mapRenderCertificationsToIndicatorProps(props) {
    var asset = props.kind === 'graph' ? {
        kind: 'graph',
        asset: props.anchoredAsset,
    } : {
        kind: 'vizportal',
        asset: props.anchoredAsset,
    };
    var partial = {
        subjectArea: props.subjectArea,
        assetName: assetName(asset),
        assetType: assetType(asset),
        assetUrl: assetUrl(props.urls, asset),
    };
    switch (props.kind) {
        case 'graph':
            return __assign(__assign({}, partial), { linksDisabled: props.linksDisabled, indicators: props.anchoredCertifications.filter(function (t) { return t.isActive; }).map(function (t) { return mapFragmentOrIDataQualityIndicatorToRenderIndicatorProps(__assign({ kind: 'graph' }, t)); }), childrenIndicatorAndAsset: [], upstream: [] });
        case 'vizportal':
            return __assign(__assign({}, partial), { linksDisabled: props.linksDisabled, indicators: props.anchoredCertifications.filter(function (t) { return t.isActive; }).map(function (t) { return mapFragmentOrIDataQualityIndicatorToRenderIndicatorProps(__assign({ kind: 'vizportal' }, t)); }), childrenIndicatorAndAsset: [], upstream: [] });
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(props);
            return {};
    }
}
exports.mapRenderCertificationsToIndicatorProps = mapRenderCertificationsToIndicatorProps;
function dataQualityKind(fragment) {
    switch (fragment.__typename) {
        case 'DataQualityCertification':
            return 'certification';
        case 'DataQualityWarning':
            return fragment.isSevere ? 'severe-warning' : 'standard-warning';
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(fragment);
            return 'certification';
    }
}
function dataQualityKindFromVizportal(fragment) {
    var type = (0, DataQualityType_1.stringToDataQualityType)(fragment.type);
    if (type === DataQualityType_1.DataQualityType.CERTIFIED) {
        return 'certification';
    }
    else {
        if (fragment.isSevere) {
            return 'severe-warning';
        }
        else {
            return 'standard-warning';
        }
    }
}
function dataQualityType(fragment) {
    switch (fragment.__typename) {
        case 'DataQualityCertification':
            return DataQualityType_1.DataQualityType.CERTIFIED;
        case 'DataQualityWarning':
            return (0, DataQualityType_1.stringToDataQualityType)(fragment.warningType);
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(fragment);
            return DataQualityType_1.DataQualityType.WARNING;
    }
}
function mapFragmentToRenderIndicatorProps(fragment) {
    var _a, _b, _c, _d, _e;
    return {
        linksDisabled: fragment.linksDisabled,
        newTab: fragment.newTab,
        author: {
            name: ((_a = fragment.author) === null || _a === void 0 ? void 0 : _a.name) || fragment.authorDisplayName,
            username: (_c = (_b = fragment.author) === null || _b === void 0 ? void 0 : _b.username) !== null && _c !== void 0 ? _c : null,
            domain: (_e = (_d = fragment.author) === null || _d === void 0 ? void 0 : _d.domain) !== null && _e !== void 0 ? _e : null
        },
        localizedDate: Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(fragment.updatedAt)),
        message: fragment.message,
        type: dataQualityType(fragment),
        kind: dataQualityKind(fragment),
        id: fragment.id,
    };
}
function mapVizportalToRenderIndicatorProps(fragment) {
    return {
        linksDisabled: fragment.linksDisabled,
        newTab: fragment.newTab,
        author: {
            name: fragment.owner.displayName,
            username: fragment.owner.username,
            domain: fragment.owner.domainName || null
        },
        localizedDate: fragment.updatedAt ? Localize_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(fragment.updatedAt)) : '',
        message: fragment.message,
        type: (0, DataQualityType_1.stringToDataQualityType)(fragment.type),
        kind: dataQualityKindFromVizportal(fragment),
        id: fragment.id,
    };
}
function mapFragmentOrIDataQualityIndicatorToRenderIndicatorProps(fragment) {
    switch (fragment.kind) {
        case 'graph':
            return mapFragmentToRenderIndicatorProps(fragment);
        case 'vizportal':
            return mapVizportalToRenderIndicatorProps(fragment);
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(fragment);
            return {};
    }
}
function assetName(props) {
    var _a, _b, _c, _d, _e;
    switch (props.kind) {
        case 'graph':
            return (_c = (_b = (_a = props.asset) === null || _a === void 0 ? void 0 : _a.asset) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '';
        case 'vizportal':
            return (_e = (_d = props.asset) === null || _d === void 0 ? void 0 : _d.assetName) !== null && _e !== void 0 ? _e : '';
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(props);
            return '';
    }
}
function assetType(props) {
    var _a, _b, _c;
    switch (props.kind) {
        case 'graph':
            return ((_b = (_a = props.asset) === null || _a === void 0 ? void 0 : _a.asset) === null || _b === void 0 ? void 0 : _b.__typename) || null;
        case 'vizportal':
            return ((_c = props.asset) === null || _c === void 0 ? void 0 : _c.assetType) || null;
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(props);
            return null;
    }
}
function assetUrl(urls, fragment) {
    var _a, _b, _c;
    if (!urls) {
        return null;
    }
    if (fragment.kind === 'vizportal') {
        return ((_a = fragment.asset) === null || _a === void 0 ? void 0 : _a.assetUrl(urls)) || '';
    }
    var asset = (_b = fragment.asset) === null || _b === void 0 ? void 0 : _b.asset;
    if (!asset) {
        return '';
    }
    switch (asset.__typename) {
        case 'Column':
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return ((_c = asset.table) === null || _c === void 0 ? void 0 : _c.__typename) === 'DatabaseTable' ? urls.catalogTableColumnUrl(asset.table.id, asset.id) : '';
        case 'Flow':
            return urls.flowUrl(asset.vizportalUrlId);
        case 'PublishedDatasource':
            return urls.datasourceUrl(asset.vizportalUrlId);
        case 'DatabaseServer':
        case 'CloudFile':
        case 'File':
        case 'WebDataConnector':
            return urls.catalogDatabaseUrl(asset.id);
        case 'VirtualConnectionTable':
        case 'DatabaseTable':
            return urls.catalogTableUrl(asset.id);
        case 'VirtualConnection':
            return urls.virtualConnectionUrl(asset.id);
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(asset);
            return '';
    }
}
//# sourceMappingURL=DataQualityIndicatorFragments.js.map